import { BadgeCheck } from 'lucide-react'
import React from 'react'

const CustomCard = ({ title, description, image }) => {
    return (
        <article className="card home-service-card">
            <div className="home-service-card__media">
                <img src={image} alt={title} />
            </div>

            <div className="home-service-card__body">
                <h3>{title}</h3>

                <div className="home-service-card__points">
                    {Array.isArray(description)
                        ? description.map((item, index) => (
                            <p key={index}>
                                <BadgeCheck size={18} />
                                <span>{item}</span>
                            </p>
                        ))
                        : <p>{description}</p>}
                </div>
            </div>
        </article>
    )
}

export default CustomCard
